import { render, staticRenderFns } from "./commissionOverview.vue?vue&type=template&id=c060620e&scoped=true"
import script from "./commissionOverview.vue?vue&type=script&lang=js"
export * from "./commissionOverview.vue?vue&type=script&lang=js"
import style0 from "./commissionOverview.vue?vue&type=style&index=0&id=c060620e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c060620e",
  null
  
)

export default component.exports